/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
import React from 'react';
export default function ConfirmSignUp({ confirmSignUp, updateFormState }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto h-16 w-auto"
          src="/logo512.png"
          alt="Workflow"
        />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Enter your verification code
        </h2>

      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Check your email account including Junk Email folder
            </label>
            <div className="mt-1">
              <input id="confirmationCode" name="confirmationCode" required
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sprimary-500 focus:border-sprimary-500 sm:text-sm"
                placeholder="Enter verification code"
                     onChange={e => { e.persist(); updateFormState(e); }}
              >

              </input>
            </div>
          </div>

          <div className="pt-4">
            <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-sprimary-600 hover:bg-sprimary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sprimary-500"
              onClick={confirmSignUp}
            >
              Confirm Sign Up
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
